/**
 * @generated SignedSource<<a1329d60f111fbc79f46056b7f6063b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MeetingCopilotAutoPublishSettingsMutation$variables = {
  enabled: boolean;
  externalRecordingsChannelId?: string | null;
  internalRecordingsChannelId?: string | null;
};
export type MeetingCopilotAutoPublishSettingsMutation$data = {
  readonly updateUserRecordingAutoPublishSettings: {
    readonly settings: {
      readonly enabled: boolean;
      readonly externalRecordingsChannel: {
        readonly id: string;
        readonly name: string;
      } | null;
      readonly id: string;
      readonly internalRecordingsChannel: {
        readonly id: string;
        readonly name: string;
      } | null;
    } | null;
  } | null;
};
export type MeetingCopilotAutoPublishSettingsMutation$rawResponse = {
  readonly updateUserRecordingAutoPublishSettings: {
    readonly settings: {
      readonly enabled: boolean;
      readonly externalRecordingsChannel: {
        readonly id: string;
        readonly name: string;
      } | null;
      readonly id: string;
      readonly internalRecordingsChannel: {
        readonly id: string;
        readonly name: string;
      } | null;
    } | null;
  } | null;
};
export type MeetingCopilotAutoPublishSettingsMutation = {
  rawResponse: MeetingCopilotAutoPublishSettingsMutation$rawResponse;
  response: MeetingCopilotAutoPublishSettingsMutation$data;
  variables: MeetingCopilotAutoPublishSettingsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "enabled"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "externalRecordingsChannelId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "internalRecordingsChannelId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "enabled",
        "variableName": "enabled"
      },
      {
        "kind": "Variable",
        "name": "externalRecordingsChannelId",
        "variableName": "externalRecordingsChannelId"
      },
      {
        "kind": "Variable",
        "name": "internalRecordingsChannelId",
        "variableName": "internalRecordingsChannelId"
      }
    ],
    "concreteType": "UpdateUserRecordingAutoPublishSettings",
    "kind": "LinkedField",
    "name": "updateUserRecordingAutoPublishSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserRecordingAutoPublishSettings",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Channel",
            "kind": "LinkedField",
            "name": "externalRecordingsChannel",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Channel",
            "kind": "LinkedField",
            "name": "internalRecordingsChannel",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MeetingCopilotAutoPublishSettingsMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MeetingCopilotAutoPublishSettingsMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "0b768fb005c060b7ded8be39adccc712",
    "id": null,
    "metadata": {},
    "name": "MeetingCopilotAutoPublishSettingsMutation",
    "operationKind": "mutation",
    "text": "mutation MeetingCopilotAutoPublishSettingsMutation(\n  $enabled: Boolean!\n  $externalRecordingsChannelId: ID\n  $internalRecordingsChannelId: ID\n) {\n  updateUserRecordingAutoPublishSettings(enabled: $enabled, externalRecordingsChannelId: $externalRecordingsChannelId, internalRecordingsChannelId: $internalRecordingsChannelId) {\n    settings {\n      id\n      enabled\n      externalRecordingsChannel {\n        id\n        name\n      }\n      internalRecordingsChannel {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "49ad33a16de91be1dbc386ffbb253ed7";

export default node;
